"use strict";
exports.defaultTranslations = {
    indexColumn: 'index',
    selectColumn: 'select',
    expandColumn: 'expand',
    paginationLimit: 'Limit',
    paginationRange: 'Results'
};
//# sourceMappingURL=/types/default-translations.type.js.map


//////////////////
// WEBPACK FOOTER
// D:/xampp_bk/htdocs/xampp/organicshop/~/angular-4-data-table/dist/types/default-translations.type.js
// module id = ../../../../angular-4-data-table/dist/types/default-translations.type.js
// module chunks = 3